export const listOfNewsCategory = [
  { name: 'services', value: 'ABOUT_SERVICES' },
  { name: 'analytics', value: 'ANALYTICS' },
  { name: 'guides', value: 'GUIDES' },
  { name: 'interviews', value: 'INTERVIEWS' },
  { name: 'market', value: 'MARKET_NEWS' },
  { name: 'cases', value: 'CASES' },
  { name: 'reviews', value: 'REVIEWS' },
];
